import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import Button from "../../components/Button.jsx";

export default function NoProjectSelected() {
    let {t} = useTranslation();
    let navigate = useNavigate();

    return (
        <main className="grow">
            <div className="px-4 sm:px-6 lg:px-8 w-full max-w-9xl mx-auto">
                <div className="max-w-2xl m-auto mt-16">
                    <div className="text-center px-4">
                        <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-2">
                            {t('project.no-permissions')}
                        </h2>
                        <div className="mb-6">
                            {t('project.wait-for-role')}
                        </div>
                        <Button variant="outline-violet" onClick={() => navigate('/sign/out')}>
                            {t('auth.sign-out')}
                        </Button>
                    </div>
                </div>
            </div>
        </main>
    );
}
